export default {
  name: "ChooseLegacyCTA",

  data() {
    return ({
      selected_asset_key: "food_cart",

      cta_data: {
        kicker: "Your Invitation",
        title_line_1: "Choose Your Legacy.",
        title_line_2: "Adopt an Asset.",
        subtitle_accent: "Become the Market Maker",
        subtitle_rest: "who buys outcomes, not promises.",
        cta_text: "Begin Your Legacy",
        cta_link: "#begin",
        quote:
          "South Africa creates dependency because we fund relief. We need a model that creates taxpayers.",
      },

      assets: [
        { key: "food_cart", title: "Food Cart", meta: "50 Notes (R50,000)" },
        { key: "tech_hub", title: "Tech Hub", meta: "50 Notes (R50,000)" },
        { key: "creative_kit", title: "Creative Kit", meta: "20 Notes (R20,000)" },
        { key: "terminal", title: "Terminal", meta: "3 Notes (R3,000)" },
      ],
    });
  },

  methods: {
    select_asset(asset_key) {
      this.selected_asset_key = asset_key;
    },
  },
};
